"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPPER = void 0;
exports.UPPER = {
    alias: 'MAIUSCULAS',
    description: 'Retorna o texto em maiúsculas',
    arg_names: ['string_to_maiusculas'],
    args_description: ['texto que será transformado em maiúsculas'],
};
